// eslint-disable-next-line import/prefer-default-export

export const truncateText = (str, maxLen, screenWidth, minLen) => {
  if (screenWidth < 415) {
    if (str.length > minLen) {
      return `${str.substr(0, minLen)}...`;
    }
    return str;
  }
  if (str.length > maxLen) {
    return `${str.substr(0, maxLen)}...`;
  }
  return str;
};
